import { Module } from "@webmotors/ioc";
import { LoggerModule } from "../logger";
import { InsiderTagService } from "./insider-tag.service";

export const InsiderModule: Module = {
  name: "InsiderModule",
  modules: [LoggerModule],
  providers: [InsiderTagService],
};
